export default __webpack_public_path__ + "static/media/sample-probono.173bf2ed.png";